import { ANALYTICS_APP_QUERY } from "@/features/accountTour/model/sections";

/**
 * Телефонный кабинет как приложение MY REVIVE из Google Play (предпросмотр).
 *
 * Владелец, 30.09: на телефоне кабинет сайта выглядит и ходит ровно как
 * приложение — та же нижняя панель, те же вкладки и экраны; у сайта могут быть
 * свои дополнительные части. Пока это видят только админы (как меню V5);
 * компьютер и всё остальное не меняются ни на пиксель.
 *
 * Три рубильника, все здесь:
 *  - APP_SHELL_PREVIEW — главный: false убирает оболочку у всех разом (откат);
 *  - APP_SHELL_FOR_ALL — «открыть всем», только после «да» владельца;
 *  - APP_SHELL_OPT_OUT_KEY — ключ localStorage для плитки админа «Прежний вид
 *    сайта (телефон)»: "1" — у этого браузера оболочки нет.
 */
export const APP_SHELL_PREVIEW = true;
export const APP_SHELL_FOR_ALL = false;
export const APP_SHELL_OPT_OUT_KEY = "app_shell_off";

/**
 * Ряд разделов вкладок-страниц сайта (TabSections, tabSections.ts) на
 * телефоне — в оболочке и в окне приложения. В окне приложения его видит и
 * обычный человек (вкладки «Прогресс и лига», «Диета и диагностика», «Умный
 * поиск» и «Курсы» приложения открывают страницы сайта — владелец, 09.10:
 * «там должен иметь возможность переходить в другие части вкладки»), хотя
 * сама оболочка ему пока не включена (APP_SHELL_FOR_ALL). false — ряда нет
 * ни у кого (откат).
 */
export const TAB_SECTIONS_ON = true;

/**
 * Ключ localStorage: адрес последнего подтверждённого админа на этом браузере.
 * Список динамических админов приходит с сервера не сразу, а до него ответ —
 * «нет»; по этой подсказке первый же рисунок кабинета у такого админа —
 * оболочка (без фото фона и прежней шапки). Список сказал «нет» — ключ
 * стирается; другой человек на том же браузере подсказки не получает.
 */
export const APP_SHELL_ADMIN_HINT_KEY = "app_shell_admin";

/**
 * Когда кабинет — телефон: узкое окно или телефон боком (низкий экран с
 * сенсором: 844×390 шире 768, но это тот же телефон, и поворот не должен
 * выкидывать на сайт). Тот же запрос, что у слоя «Аналитика и баллы», — один
 * на оба, иначе на повороте слой и оболочка разошлись бы.
 */
export const APP_SHELL_QUERY = ANALYTICS_APP_QUERY;

/**
 * Пометки на <html>, пока оболочка включена (их ставит PhoneShell, как
 * AnalyticsApp ставит html[data-analytics-app]). Все стили «как в приложении»
 * написаны под html[data-app-shell] — без пометки их нет, и обычный человек
 * получает сегодняшний сайт. На <html>, а не на кабинете: окна MUI и шторки
 * рисуются порталом в body и тоже должны видеть цвета приложения.
 */
export const APP_SHELL_ATTR = "data-app-shell";
export const APP_WINDOW_ATTR = "data-app-window";
